import * as React from 'react';
import { compose } from 'recompose';
import { InjectedFormProps } from 'redux-form';
import { reduxForm } from 'redux-form';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';

import * as actions from './actions';

import PATHS from '../../constants/paths';

import AuthForm from './AuthForm';

import IMPComponent from '../../components/interfaces/IMPComponent';

import { makeGetGlobalAuthFormErrors } from './selectors';
import withActionsDispatch from '../../hocs/withActionsDispatch';
import { authClearGlobalFormErrors, authSubmitSignInForm } from './actions';

interface ISigninFormProps extends IMPComponent {
  submitSignInForm: typeof authSubmitSignInForm;
  globalErrors: string[];
}

const MESSAGE_BASE = 'containers.Auth.SignInForm';

export const SIGN_IN_FORM = 'SIGN_IN_FORM';

class SignInForm extends React.Component<ISigninFormProps & InjectedIntlProps & InjectedFormProps> {
  public render() {
    const { handleSubmit, intl, ...formProps } = this.props;

    return (
      <AuthForm
        linkPath={PATHS.AUTH.SIGN_UP}
        messageBase={MESSAGE_BASE}
        intl={intl}
        onSubmit={handleSubmit(this.onSubmit)}
        {...(formProps as any)}
      />
    );
  }

  private onSubmit = () => {
    this.props.submitSignInForm();
  };
}

const enhance = compose<ISigninFormProps & InjectedIntlProps, ISigninFormProps>(
  injectIntl,
  reduxForm({
    form: SIGN_IN_FORM,
  }),
  connect(
    state => {
      return {
        globalErrors: makeGetGlobalAuthFormErrors(SIGN_IN_FORM)(state),
      };
    },
    {
      submitSignInForm: actions.authSubmitSignInForm,
    },
  ),
  withActionsDispatch({
    onMount: [],
    onUnmount: [authClearGlobalFormErrors(SIGN_IN_FORM)],
  }),
);
export default enhance(SignInForm);



// WEBPACK FOOTER //
// ./src/containers/Auth/SignInForm.tsx